import {useCallback, useMemo} from 'react'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'
import {hasOwnPropertyCall} from '@components/lib'

import {ENV} from 'config'

const ReactQueryProvider = ({children}) => {
  const {enqueueSnackbar} = useSnackbar()

  const onError = useCallback(
    err => {
      // if CancelQuery error - do not show
      if (err && hasOwnPropertyCall(err, 'silent')) return

      // eslint-disable-next-line no-console
      if (ENV === 'development') console.error(err)

      enqueueSnackbar(`${err?.toString()}`, {
        variant: 'error',
        preventDuplicate: true,
        persist: true,
      })
    },
    [enqueueSnackbar],
  )

  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            retry: (failureCount, error) => {
              if (error?.status < 500) return false
              return failureCount < 2
            },
            onError,
          },
          mutations: {
            onError,
          },
        },
      }),
    [onError],
  )
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export default ReactQueryProvider
